import React from 'react'

/**
 * Full-screen empty-state hero. One CTA — see `docs/contributor/design-language.md` §6.7.
 *
 * Props:
 *   - icon:    optional ReactNode rendered above the title (e.g. an <img> or <Icon>)
 *   - title:   the heading
 *   - body:    supporting copy
 *   - action:  optional ReactNode for the CTA (typically a <Button>)
 *   - footer:  optional ReactNode for tagline / fine print
 */
export function EmptyState({ icon, title, body, action, footer, className = '', ...rest }) {
  const classes = ['empty-state', className].filter(Boolean).join(' ')
  return (
    <div className={classes} {...rest}>
      {icon ? <div className="empty-state__icon">{icon}</div> : null}
      {title ? <h1 className="empty-state__title">{title}</h1> : null}
      {body ? <p className="empty-state__body">{body}</p> : null}
      {action}
      {footer}
    </div>
  )
}
